import store from '../store'

export default function auth(to, from, next) {
  if (!store.getters['auth/isAuthenticated']) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else {
    next()
  }
}
